import { render, staticRenderFns } from "./HuaxianNewList.vue?vue&type=template&id=4e0d6c20&scoped=true&"
import script from "./HuaxianNewList.vue?vue&type=script&lang=js&"
export * from "./HuaxianNewList.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianNewList.vue?vue&type=style&index=0&id=4e0d6c20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0d6c20",
  null
  
)

export default component.exports